import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useAsyncDialog } from "../../sharedComponents/useAsyncDialog";

export function useDeleteCalculationConfirmationDialog() {
  return useAsyncDialog(({ onCancel, onAccept }) => (
    <Dialog open={true} onClose={onCancel}>
      <DialogTitle>Usuń kalkulację</DialogTitle>
      <DialogContent>
        <DialogContentText>Czy na pewno chcesz usunąć tę kalkulację? Operacja jest nieodwracalna.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Anuluj</Button>
        <Button color="error" onClick={onAccept}>
          Usuń
        </Button>
      </DialogActions>
    </Dialog>
  ));
}
